export const RELOAD_INTERVAL_INCOMING_DELIVERIES = 30000;
